import type { DeadAirCategory } from "./deadAirTypes";

import { DEAD_AIR_CATEGORIES } from "./deadAirTypes";

/**
 * The categories the assistant is allowed to try to fill. Each describes a silence caused by the
 * agent reaching for information or a system the assistant can potentially provide:
 *  - LOOKUP_STALL: the agent is researching an answer.
 *  - RE_ASK: the agent is re-collecting information the customer already gave.
 *  - SYSTEM_NAV: the agent is waiting on a tool or system to navigate.
 */
export const FILLABLE_CATEGORIES: ReadonlySet<DeadAirCategory> = new Set<DeadAirCategory>([
    "LOOKUP_STALL",
    "RE_ASK",
    "SYSTEM_NAV",
]);

/** Whether the assistant may attempt to fill a silence of this category. */
export function isFillableCategory(category: DeadAirCategory): boolean {
    return FILLABLE_CATEGORIES.has(category);
}

/** Runtime guard that a value is one of the eight known dead-air categories. */
export function isDeadAirCategory(value: unknown): value is DeadAirCategory {
    return typeof value === "string" && (DEAD_AIR_CATEGORIES as readonly string[]).includes(value);
}
